import { render, staticRenderFns } from "./Textolegal.vue?vue&type=template&id=65725a25&scoped=true&lang=pug&"
import script from "./Textolegal.vue?vue&type=script&lang=js&"
export * from "./Textolegal.vue?vue&type=script&lang=js&"
import style0 from "./Textolegal.styl?vue&type=style&index=0&id=65725a25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65725a25",
  null
  
)

export default component.exports